import { AuthConfig } from 'angular-oauth2-oidc';

//https://github.com/shaheershukur/Angular-Single-Sign-On-OAuth2-OIDC-/blob/master/src/app/sso.config.ts
//https://www.youtube.com/watch?v=AcuzemsJfxA&ab_channel=ShaheerShukur
export const authConfig: AuthConfig = {

  // Url of the Identity Provider
  issuer: 'https://steyer-identity-server.azurewebsites.net/identity',

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin + '/index.html',

  //redirectUri: "window.location.origin" + '/index.html',

  //redirectUri: window.location.origin + '/auth2/test-auth2',



  // The SPA's id. The SPA is registerd with this id at the auth-server
  clientId: 'spa-demo',

  // set the scope for the permissions the client should request
  // The first three are defined by OIDC. The 4th is a usecase-specific one
  scope: 'openid profile email voucher',

  //https://github.com/manfredsteyer/angular-oauth2-oidc/blob/master/docs-src/code-flow.bak.md
  //responseType: 'code',
}
